import React, { useEffect, useState } from 'react';
import { FiLogOut } from 'react-icons/fi';

const Header = ({ user, onLogout, banner, appMode }) => {

//  const BANNER_URL = window.API_BASE_URL + "/api/banner";
//  const initials =
//    (user.first_name ? user.first_name.slice(0, 1).toUpperCase() : "") +
//    (user.last_name ? user.last_name.slice(0, 1).toUpperCase() : "");  

  const getInitials = () => {
    if (user.first_name && user.last_name) {
      return (
        user.first_name.charAt(0).toUpperCase() +
        user.last_name.charAt(0).toUpperCase()
      );
    }
    if (user.name) {
      return user.name.slice(0, 2).toUpperCase();
    }
    return "?";
  };

//  const [banner, setBanner] = useState("");
//  const [mode, setMode] = useState("");
//
//  useEffect(() => {
//    fetch(`${BANNER_URL}`)
//      .then((res) => res.json())
//      .then((data) => setBanner(data.banner || ""));
//      
//    fetch(window.API_BASE_URL + "/api/app-mode")
//      .then((res) => res.json())
//      .then((data) => setMode(data.mode || ""));
//      
//  }, []);
  


  return (
<header className="bg-cyan-900 text-white px-4 sm:px-6 py-3 shadow">
  <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0">
    
    {/* Top row: Title + Avatar + Logout */}
    <div className="w-full flex items-center justify-between">
      {/* Left: Dashboard title */}
      <h1 className="text-base sm:text-lg font-semibold">
        UTwin Dashboard
      </h1>

      {/* Right: Avatar + Logout */}
      <div className="flex items-center gap-3 sm:gap-4">
        {/* Avatar */}
        <div className="relative group cursor-pointer">
          <div className="w-8 h-8 sm:w-10 sm:h-10 bg-white text-cyan-900 rounded-full flex items-center justify-center font-semibold text-sm sm:text-base">
            {getInitials()}
          </div>
          <div className="absolute bottom-[-35px] left-1/2 -translate-x-1/2 whitespace-nowrap text-xs bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition z-50 shadow-lg">
            {user.role === "doctor"
              ? "Dr. " + user.first_name + " " + user.last_name
              : (user.first_name && user.last_name)
              ? user.first_name + " " + user.last_name
              : user.username}
          </div>
        </div>

        {/* Logout */}
        <button
          onClick={onLogout}
          className="flex items-center gap-1 sm:gap-2 text-white hover:text-gray-200 text-xs sm:text-sm"
          title="Logout"
        >
          <FiLogOut className="text-sm sm:text-base" />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </div>

    {/* Bottom row (mobile) / Center overlay (desktop): Banner */}
    {banner && (
      <div className="w-full text-center sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2 sm:w-auto">
        <span
          className="text-sm sm:text-xl font-extrabold tracking-wider break-words
                     bg-gradient-to-r from-pink-400 via-yellow-300 to-cyan-300
                     bg-clip-text text-transparent
                     drop-shadow-[2px_2px_4px_rgba(0,0,0,0.6)]
                     animate-pulse"
        >
          {banner}
        </span>
      </div>
    )}
  </div>
</header>



  );
};

export default Header;
